import { UseFormHandleSubmit } from "react-hook-form";
import ClientDetailsContainer from "../../component/brokers/constructionSites/ClientDetailsContainer";
import SelectOrCreateClientContainer from "../../component/brokers/constructionSites/SelectOrCreateClientContainer";
import { CreateConstructionSiteClientFormData } from "../../component/brokers/constructionSites/useCreateConstructionSiteForm";
import { ConstructionSiteDetailsFormData } from "../../component/brokers/constructionSites/useConstructionSiteDetailsForm";
import { useMemo } from "react";
import { useMe } from "../../api/queries/users.queries";
import { SelectedClient } from "./projectForm/CommonProjectForm";
import { RoleEnum } from "../../../../../packages/vars/src";
import { toast } from "sonner";

interface ConstructionSiteClientSelectProps {
	handleSubmit: UseFormHandleSubmit<CreateConstructionSiteClientFormData>;
	onSubmit: (data: CreateConstructionSiteClientFormData) => void;
	selectedClient: SelectedClient;
	setSelectedClient: (client: SelectedClient) => void;
	canValidate: boolean;
	actionsValue: ConstructionSiteDetailsFormData["actions"];
	excludeSyndics: boolean;
	initialClientSocietyId: number | null;
}

const ConstructionSiteClientSelect = ({
	handleSubmit,
	onSubmit,
	selectedClient,
	setSelectedClient,
	canValidate,
	actionsValue,
	excludeSyndics,
	initialClientSocietyId,
}: ConstructionSiteClientSelectProps) => {
	const { me } = useMe();
	const currentUserIsSyndic = useMemo(
		() => me?.role === RoleEnum.SYNDIC,
		[me?.role],
	);
	const currentUserIsClient = useMemo(
		() => currentUserIsSyndic && actionsValue?.buildingType === "COMMON_PARTS",
		[currentUserIsSyndic, actionsValue?.buildingType],
	);

	return (
		<form
			onSubmit={handleSubmit(onSubmit, (errors) => {
				toast.warning("Veuillez corriger les erreurs du formulaire");
				console.log(errors);
			})}
			className="flex flex-col items-center justify-center p-6 w-[70%]"
		>
			{selectedClient !== undefined ? (
				<ClientDetailsContainer
					client={selectedClient}
					setSelectedClient={setSelectedClient}
					canValidate={canValidate}
					currentUserIsClient={currentUserIsClient}
					excludeSyndics={excludeSyndics}
					initialClientSocietyId={initialClientSocietyId}
				/>
			) : (
				<SelectOrCreateClientContainer
					setSelectedClient={setSelectedClient}
					excludeSyndics={excludeSyndics}
				/>
			)}
		</form>
	);
};

export default ConstructionSiteClientSelect;
